var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookingConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 80,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    x: 0.5,
    fill: "#F9FBFB",
    rx: 40
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#006",
    d: "m55.893 60-33.502-6.076 7.21-32.248 30.825 9.937C58.073 45.053 56.81 57.443 55.893 60"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D72F4",
    d: "M53.662 59 21.5 51.607c1.924-2.284 4.272-13.722 6.598-24.692q.297-1.4.44-2.825L28.85 21 60 28.01l-.283 2.663a26.4 26.4 0 0 1-.76 4.075C56.084 45.421 53.45 55.536 53.662 59"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006",
    d: "M36.984 47.716a.64.64 0 0 1-.61-.44l-3.863-11.59a.644.644 0 1 1 1.221-.408l3.534 10.602L49.664 33.48a.644.644 0 0 1 .91.911L37.44 47.527a.65.65 0 0 1-.456.188"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.5 20h40v40h-40z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingConfirm);
export default __webpack_public_path__ + "static/media/booking-confirm.34fe0dde36009f67974427c10104c618.svg";
export { ForwardRef as ReactComponent };